import React, { useEffect, useState, useCallback } from "react";
import { 
  CreateTable,
  SuccessMessage,
  FailMessage,
  Loading,
  GLAccountSubTypeSelect,
  GLAccountSubTypeSelectWithAll,
  FormatValueToDecimal,
  TabButton,
  ChartOfAccountsSelect, PostingKeySelect,
  SubAccountsSelect,
  ConfirmationModal
} from "../../common/APICommon";
import { apiUrl } from "../../utils/Configuration";
import NoAccess from "../NoAccess";
import axios from 'axios';
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import EditIcon from '@mui/icons-material/Edit';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ArticleIcon from '@mui/icons-material/Article';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import SettingsIcon from '@mui/icons-material/Settings';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import TuneIcon from '@mui/icons-material/Tune';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import DownloadIcon from '@mui/icons-material/FileDownload';
import UploadIcon from '@mui/icons-material/FileUpload';
import TableViewIcon from '@mui/icons-material/TableView';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DeleteIcon from '@mui/icons-material/Delete';

export default function GLAccounts() {
  const [view, setView] = useState("Main");
  const [mainAccount, setMainAccount] = useState(null);



//#region UI
  return (
    <>
      { view === "Main" ? <MainView 
                            view={view} setView={setView} 
                            mainAccount={mainAccount} setMainAccount={setMainAccount} 
                          />
        : view === "Sub Account" ? <SubMainView 
                                        view={view} setView={setView}
                                        mainAccount={mainAccount} setMainAccount={setMainAccount} 
                                      />
        : <></>
      }
    </>
  );
//#endregion
}








//#region Main View
function MainView({
  view, setView,
  mainAccount, setMainAccount,
}) {
//#region Others
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState("");

  const handleSearch = (value) => {
    setSearch(value);
    setCurrentPage(1)
    const lowerValue = value.toLowerCase();

    const filtered = filteredData.filter(
      (item) =>
        item.accountNumber.toLowerCase().includes(lowerValue) ||
        item.accountName.toLowerCase().includes(lowerValue) ||
        item.id.toString().includes(lowerValue)
    );

    setData(filtered);
  };
//#endregion





//#region Filters
  const [showFilterForm, setShowFilterForm] = useState(false);
  const [glAccountSubTypeFilter, setGLAccountSubTypeFilter] = useState(null);
  const openFilterForm = () => {
    setShowFilterForm(true);
  }
  const closeFilterForm = () => {
    setShowFilterForm(false);
  }
//#endregion









//#region Variables
  const [selectedData, setSelectedData] = useState(null);
  const [accountNumber, setAccountNumber] = useState("");
  const [accountName, setAccountName] = useState("");
  const [glAccountSubType, setGLAccountSubType] = useState(null);
  const [isActive, setIsActive] = useState(true);

  const resetVariables = () => {
    setAccountNumber("");
    setAccountName("");
    setGLAccountSubType(null);
    setIsActive(true);
    setSelectedData(null);
  }

  const fetchDataById = useCallback(async (_data) => {
    try {
      const response = await axios.get(`${apiUrl}/api/GLAccount/${_data?.id}` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return null
    }
  }, []);
//#endregion




// #region Add function
  const [showAddForm, setShowAddForm] = useState(false);
  
  const openAddForm = () => {
    setShowAddForm(true);
  }
  const closeAddForm = () => {
    setShowAddForm(false);
    resetVariables();
  }

  const handleAddData = async () => {
    const data = {
      accountNumber: accountNumber,
      accountName: accountName,
      glAccountSubTypeId: glAccountSubType?.id,
      isActive: isActive,
      createdBy: accountData?.id,
    };

    try {
      setLoading(true);

      await axios.post(`${apiUrl}/api/GLAccount`, data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data added successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  } 
//#endregion




// #region Update function
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  
  const openUpdateForm = () => {
    setShowUpdateForm(true);
  }
  const closeUpdateForm = () => {
    setShowUpdateForm(false);
    resetVariables();
  }

  const editHandleClick = (data) => {
    setSelectedData(data);

    setAccountNumber(data.accountNumber);
    setAccountName(data.accountName);
    setGLAccountSubType(data.glAccountSubType);
    setIsActive(data.isActive);

    openUpdateForm();
  }

  const handleUpdateData = async () => {
    const data = {
      accountNumber: accountNumber,
      accountName: accountName,
      glAccountSubTypeId: glAccountSubType?.id,
      isActive: isActive,
      updatedBy: accountData?.id,
    };

    try {
      setLoading(true);

      await axios.put(`${apiUrl}/api/GLAccount/${selectedData?.id}`, data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data updated successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  } 
//#endregion





//#region child account
  const childAccountHandleClick = async (_data) => {
    setMainAccount(_data)
    setView("Sub Account")
  }
//#endregion






// #region Transaction function
  const [showTransactionForm, setShowTransactionForm] = useState(false);
  
  const openTransactionForm = () => {
    setShowTransactionForm(true);
  }
  const closeTransactionForm = () => {
    setShowTransactionForm(false);
    resetVariables();
  }

  const transactionHandleClick = async (data) => {
    setLoading(true);

    const _data = await fetchDataById(data)
    setSelectedData(_data);

    setLoading(false)
    openTransactionForm();
  }
//#endregion






//#region Table data
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);

  const headers = [
    'ID', 
    'ACCOUNT', 
    // 'ACCOUNT NUMBER', 
    // 'ACCOUNT NAME', 
    'SUB TYPE', 
    'TRANSACTIONS', 
    'DEBIT', 
    'CREDIT', 
    'BALANCE', 
    'STATUS', 
    'ACTIONS',
  ]
  const accessors = [
    'id', 
    'account', 
    // 'accountName', 
    // 'accountNumber', 
    // 'accountName', 
    'glAccountSubTypeDescription', 
    'transactions', 
    'glAccountTransactionsDebitAmount', 
    'glAccountTransactionsCreditAmount', 
    'glAccountTransactionsBalance', 
    'isActive', 
    'actions'
  ]

  const actions = [
    { 
      name: "Edit", 
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600",
      function: editHandleClick,
      visible: true,
    },
    { 
      name: "Accounts", 
      tooltip: "accounts",
      icon: <TableViewIcon fontSize="small" />,
      className: "bg-orange-500 hover:bg-orange-600",
      function: childAccountHandleClick,
      visible: true,
    },
    { 
      name: "Transactions", 
      tooltip: "transactions",
      icon: <ArticleIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: transactionHandleClick,
      visible: false,
    },
  ];

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);

      const response = await axios.get(`${apiUrl}/api/GLAccount/sub-type/${glAccountSubTypeFilter ? glAccountSubTypeFilter?.id : 0}` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      setData(response.data)
      setFilteredData(response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  }, [glAccountSubTypeFilter]);

  useEffect(() => {
    fetchData();
  }, [fetchData])
//#endregion





//#region Check Sub Type
  const navigate = useNavigate();

  const checkSubTypeHandleClick = () => {
    navigate("/accountTypes"); // navigate to the Add Borrower page
  };
//#endregion








//#region Manage
  const [showManageForm, setShowManageForm] = useState(false);
  
  const openManageForm = () => {
    setShowManageForm(true);
  }
  const closeManageForm = () => {
    setShowManageForm(false);
  }
//#endregion










//#region gear dd
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleSettingsClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSettingsClose = () => {
    setAnchorEl(null);
  };

  const fetchSubTypeData = useCallback(async () => { 
    try {
      const response = await axios.get(`${apiUrl}/api/GLAccountSubType` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return response.data
    } catch (error) {
      console.error('Error fetching data:', error);
      return []
    }
  }, []);

  const handleDownload = async () => {
    handleSettingsClose();

    const workbook = new ExcelJS.Workbook();
    const headerColor = "4fab8e"; // your green header color
    const totalRows = 1000;

    // Helper: style header row
    const styleHeader = (sheet) => {
      const headerRow = sheet.getRow(1);
      headerRow.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: headerColor },
        };
        cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
        cell.alignment = { horizontal: "center", vertical: "middle" };
      });
    };

    // Helper: auto-size columns
    const autoSize = (sheet) => {
      sheet.columns.forEach((col) => {
        let maxLength = 12; // minimum width
        col.eachCell({ includeEmpty: true }, (cell) => {
          const len = cell.value ? cell.value.toString().length : 0;
          if (len > maxLength) maxLength = len;
        });
        col.width = maxLength + 2;
      });
    };

    const accountSheet = workbook.addWorksheet("Account");
    accountSheet.columns = [
      { header: "Account Number", key: "accountNumber" },
      { header: "Account Name", key: "accountName" },
      { header: "Account Type", key: "glAccountSubType" },
    ];

    styleHeader(accountSheet);

    // Sample row
    for (let i = 0; i < totalRows; i++) {
      if(i === 0){
        accountSheet.addRow({
          accountNumber: "<10001000>",
          accountName: "<Asset>",
          glAccountSubType: "<SELECTION HERE>", // leave blank for dropdown
        });
      } else {
        accountSheet.addRow({
          accountNumber: "",
          accountName: "",
          glAccountSubType: "\u200B",
        });
      }
    }

    // Fetch employment statuses
    const subTypes = await fetchSubTypeData();
    const subTypeList = subTypes.map(item => item.description); // ["Full-time", "Part-time", etc]

    // Apply dropdown to Sub Type column
    // Column B = 2
    accountSheet.getColumn(3).eachCell({ includeEmpty: true }, (cell, rowNumber) => {
      if (rowNumber === 1) return;
      cell.dataValidation = {
        type: 'list',
        allowBlank: true,
        formulae: [`"${subTypeList.join(",")}"`],
        showDropDown: true,
        showErrorMessage: true,
        errorStyle: 'warning',
        errorTitle: 'Invalid Selection',
        error: 'Please select a value from the list',
      };
    });

    autoSize(accountSheet);

    // ===== DOWNLOAD FILE =====
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), "Account_Template.xlsx");
  };

  const handleDownloadMasterList = async () => {
    handleSettingsClose();

    const workbook = new ExcelJS.Workbook();
    const headerColor = "4fab8e";

    // ===== Helpers =====
    const styleHeader = (sheet) => {
      const headerRow = sheet.getRow(1);

      headerRow.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: headerColor },
        };

        cell.font = {
          bold: true,
          color: { argb: "FFFFFFFF" },
        };

        cell.alignment = {
          horizontal: "center",
          vertical: "middle",
        };
      });
    };

    const autoSize = (sheet) => {
      sheet.columns.forEach((col) => {
        let maxLength = 12;

        col.eachCell({ includeEmpty: true }, (cell) => {
          const len = cell.value ? cell.value.toString().length : 0;

          if (len > maxLength) {
            maxLength = len;
          }
        });

        col.width = maxLength + 2;
      });
    };

    // ===== Worksheet =====
    const sheet = workbook.addWorksheet("Account Masterlist");

    sheet.columns = [
      // { header: "Id", key: "id" },
      { header: "Account Number", key: "accountNumber" },
      { header: "Account Name", key: "accountName" },
      // { header: "GL Account Sub Type Id", key: "glAccountSubTypeId" },
      { header: "GL Account Sub Type", key: "glAccountSubTypeDescription" },
      // { header: "Is Active", key: "isActive" },
      { header: "Debit Amount", key: "debitAmount" },
      { header: "Credit Amount", key: "creditAmount" },
      { header: "Balance", key: "balance" },
    ];

    // ===== Header Style =====
    styleHeader(sheet);

    console.log({data})

    // ===== Data Rows =====
    data.forEach((item) => {
      sheet.addRow({
        // id: item.Id,
        accountNumber: item.accountNumber,
        accountName: item.accountName,
        // glAccountSubTypeId: item.GLAccountSubTypeId,
        glAccountSubTypeDescription: item.glAccountSubTypeDescription,
        // isActive: item.IsActive ? "Yes" : "No",
        debitAmount: item.glAccountTransactionsDebitAmount || 0,
        creditAmount: item.glAccountTransactionsCreditAmount || 0,
        balance: item.glAccountTransactionsBalance || 0,
      });
    });

    // ===== Number Formatting =====
    sheet.getColumn(7).numFmt = "#,##0.00";
    sheet.getColumn(8).numFmt = "#,##0.00";
    sheet.getColumn(9).numFmt = "#,##0.00";

    // ===== Auto Size =====
    autoSize(sheet);

    // ===== Download =====
    const buffer = await workbook.xlsx.writeBuffer();

    saveAs(
      new Blob([buffer]),
      "Account_Masterlist.xlsx"
    );
  };

  const [uploadedData, setUploadedData] = useState([]);
  const [showUploadForm, setShowUploadForm] = useState(false);
  const openUploadForm = () => {
    setShowUploadForm(true);
  }
  const closeUploadForm = () => {
    setShowUploadForm(false);
    setUploadedData([])
  }

  const handleUpload = async () => {
    openUploadForm();
    handleSettingsClose();
  };

  const handleUploadFinal = async () => {
    try {
      setLoading(true);

      await axios.post(`${apiUrl}/api/GLAccount/upload`, uploadedData, {
          headers: { 'Content-Type': 'application/json' }
      });

      await fetchData();
      setSuccessMessage("Data added successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  };
//#endregion










//#region Access Template
  const accountData = JSON.parse(localStorage.getItem("accountData"));
  
  if (!accountData?.accessTemplate?.hasChartOfAccounts) {
    return <NoAccess />;
  }
//#endregion





//#region UI
  return (
    <>
      <div className="p-6 bg-gray-50 min-h-screen">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
          <div>
            <h2 className="text-3xl font-bold text-gray-800 flex items-center gap-2">
              <AccountBalanceWalletIcon fontSize="large" className="text-theme-color" />
              {`Chart of Accounts (${data?.length ?? 0})`}
            </h2>
            <p className="text-gray-500 mt-1">Main records of financial transactions summary.</p>
          </div>
          <div className="flex gap-3">
            <button onClick={checkSubTypeHandleClick} className="flex items-center gap-2 bg-white border border-gray-300 px-4 py-2 rounded-lg text-sm font-semibold hover:bg-gray-50 transition shadow-sm">
              <FormatListBulletedIcon fontSize="small" /> Check Account Types
            </button>
            <button onClick={openManageForm} className="flex items-center gap-2 bg-white border border-gray-300 px-4 py-2 rounded-lg text-sm font-semibold hover:bg-gray-50 transition shadow-sm">
              <TuneIcon fontSize="small" /> Configuration
            </button>
            <button 
              onClick={handleSettingsClick} 
              className="flex items-center gap-2 bg-white border border-gray-300 px-4 py-2 rounded-lg text-sm font-semibold hover:bg-gray-50 transition shadow-sm"
            >
              <SettingsIcon fontSize="small" />
            </button>

            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleSettingsClose}
              // This ensures it drops down directly under the button
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              PaperProps={{
                className: "mt-2 shadow-lg border border-gray-100 rounded-lg min-w-[180px]"
              }}
            >
              <MenuItem onClick={handleDownloadMasterList} className="text-gray-700 py-2">
                <ListItemIcon><DownloadIcon fontSize="small"  className="text-green-500"/></ListItemIcon>
                Accounts Masterlist
              </MenuItem>

              <MenuItem onClick={handleDownload} className="text-gray-700 py-2">
                <ListItemIcon><DownloadIcon fontSize="small"  className="text-green-500"/></ListItemIcon>
                Download Template
              </MenuItem>
              
              <MenuItem onClick={handleUpload} className="text-gray-700 py-2">
                <ListItemIcon><UploadIcon fontSize="small"  className="text-blue-500"/></ListItemIcon>
                Upload Accounts
              </MenuItem>
            </Menu>
          </div>
        </div>

        <div className="flex gap-3">
          <button className="bg-white border border-gray-300 text-theme-color hover:bg-gray-100 px-3 py-1 rounded-md flex items-center gap-2 hover:bg-opacity-90 transition"
            onClick={openFilterForm}
          >
            <FilterAltIcon/> Filter
          </button>
          <button onClick={openAddForm} className="flex items-center gap-2 bg-theme-color text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-theme-color-h transition shadow-md">
            <AddCircleOutlineIcon fontSize="small" /> New Accounts
          </button>
        </div>

        {/* Search and Filters */}
        <div className="flex justify-between items-center gap-2 mt-4">
          <div className="mb-4 w-full">
            <input
              type="text"
              placeholder="Search by account number or name or ID..."
              className="px-4 py-2 border rounded-lg w-full md:w-2/3 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color"
              value={search}
              onChange={(e) => handleSearch(e.target.value)}
            />
            {/* Add filter dropdowns here if needed */}
          </div>
        </div>

        <CreateTable
          tableName={"GL Account"}
          headers={headers}
          accessors={accessors}
          data={data}
          actions={actions}

          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={10}
          totalItems={data?.length}
        />
      </div>

      <AddUpdateModal 
        visible={showAddForm}
        onClose={closeAddForm}
        onSave={handleAddData}
        modalName={"Add Data"}

        data={data}
        accountNumber={accountNumber} setAccountNumber={setAccountNumber}
        accountName={accountName} setAccountName={setAccountName}
        glAccountSubType={glAccountSubType} setGLAccountSubType={setGLAccountSubType}
        isactive={isActive} setIsactive={setIsActive}
      />

      <AddUpdateModal 
        visible={showUpdateForm}
        onClose={closeUpdateForm}
        onSave={handleUpdateData}
        modalName={"Update Data"}

        data={data}
        accountNumber={accountNumber} setAccountNumber={setAccountNumber}
        accountName={accountName} setAccountName={setAccountName}
        glAccountSubType={glAccountSubType} setGLAccountSubType={setGLAccountSubType}
        isactive={isActive} setIsactive={setIsActive}
      />

      <ManageModal 
        visible={showManageForm}
        onClose={closeManageForm}
        onSave={handleUpdateData}
        modalName={"Manage Accounts"}
      />

      <ViewTransactionModal 
        visible={showTransactionForm}
        onClose={closeTransactionForm}
        // onSave={handleUpdateData}
        modalName={"Transactions"}

        data={selectedData}
      />

      <UploadForm 
        visible={showUploadForm}
        onClose={closeUploadForm}
        modalName={"Upload Form"}
        data={data} 
        uploadedData={uploadedData} setUploadedData={setUploadedData}
        onSave={handleUploadFinal}
      />

      <FilterModal 
        visible={showFilterForm}
        onClose={closeFilterForm}
        modalName={"Filter"}

        glAccountSubTypeFilter={glAccountSubTypeFilter} setGLAccountSubTypeFilter={setGLAccountSubTypeFilter}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
//#endregion
}
//#endregion










//#region SubMain View
function SubMainView({
  view, setView,
  mainAccount, setMainAccount,
}) {
//#region Others
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
//#endregion










//#region Variables
  const [selectedData, setSelectedData] = useState(null);
  const [selectedAccounts, setSelectedAccounts] = useState([]);

  const resetVariables = () => {
    setSelectedData(null);
    setSelectedAccounts([]);
  }

  const [showSelectForm, setShowSelectForm] = useState(false)

  const openSelectForm = () => {
    setShowSelectForm(true)
  }
  const closeSelectForm = () => {
    setShowSelectForm(false)
  }

  const fetchDataById = useCallback(async (_data) => {
    try {
      const response = await axios.get(`${apiUrl}/api/GLAccount/${_data?.id}` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return null
    }
  }, []);
//#endregion










// #region Transaction function
  const [showTransactionForm, setShowTransactionForm] = useState(false);
  
  const openTransactionForm = () => {
    setShowTransactionForm(true);
  }
  const closeTransactionForm = () => {
    setShowTransactionForm(false);
    resetVariables();
  }

  const transactionHandleClick = async (data) => {
    setLoading(true);

    const _data = await fetchDataById(data)
    setSelectedData(_data);

    setLoading(false)
    openTransactionForm();
  }

  const allTransactionHandleClick = async (data) => {
    setLoading(true);

    const _data = await fetchDataById(data)
    setSelectedData(_data);

    setLoading(false)
    openTransactionForm();
  }
//#endregion















// #region Remove function
  const [showRemoveForm, setShowRemoveForm] = useState(false);
  
  const openRemoveForm = () => {
    setShowRemoveForm(true);
  }
  const closeRemoveForm = () => {
    setShowRemoveForm(false);
    resetVariables();
  }

  const removeHandleClick = async (data) => {
    setSelectedData(data);
    openRemoveForm();
  }

  const handleRemoveData = async () => {
    try {
      setLoading(true);

      const _data = {
        parentGLAccountId: mainAccount?.id,
        subAccountId: selectedData.id
      }

      await axios.post(`${apiUrl}/api/GLAccount/sub-account/delete`, _data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data deleted successfully!");
      resetVariables();
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  } 
//#endregion












//#region Table data
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);

  const headers = [
    'ID', 
    'ACCOUNT', 
    // 'ACCOUNT NUMBER', 
    // 'ACCOUNT NAME', 
    'SUB TYPE', 
    'TRANSACTIONS', 
    'DEBIT', 
    'CREDIT', 
    'BALANCE', 
    'STATUS', 
    'ACTIONS',
  ]
  const accessors = [
    'id', 
    'account', 
    // 'accountName', 
    // 'accountNumber', 
    // 'accountName', 
    'glAccountSubTypeDescription', 
    'transactions', 
    'glAccountTransactionsDebitAmount', 
    'glAccountTransactionsCreditAmount', 
    'glAccountTransactionsBalance', 
    'isActive', 
    'actions'
  ]

  const actions = [
    { 
      name: "Remove", 
      tooltip: "remove",
      icon: <DeleteIcon fontSize="small" />,
      className: "bg-red-500 hover:bg-red-600",
      function: removeHandleClick,
      visible: true,
    },
    { 
      name: "Transactions", 
      tooltip: "transactions",
      icon: <ArticleIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: transactionHandleClick,
      visible: false,
    },
  ];

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);

      const response = await axios.get(`${apiUrl}/api/GLAccount/sub-account/${mainAccount?.id}` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      setData(response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  }, [mainAccount]);

  useEffect(() => {
    if(view === "Sub Account"){
      fetchData();
    }
  }, [view, fetchData])
//#endregion












//#region Add
  const handleAddData = useCallback(async () => {
    try {
      setLoading(true);

      const _data = selectedAccounts.map((i) => ({
        parentGLAccountId: mainAccount?.id,
        subAccountId: i.id
      }))

      await axios.post(`${apiUrl}/api/GLAccount/sub-account`, _data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data added successfully!");
      resetVariables();
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  }, [selectedAccounts, mainAccount, fetchData]) 

  useEffect(() => {
    //Save sub accounts
    const saveData = async () => {
      await handleAddData();
    }

    if(selectedAccounts?.length > 0){
      saveData();
    }
  }, [handleAddData, selectedAccounts])
//#endregion











//#region Back
const backToAllList = () => {
  setView("Main")
  setMainAccount(null)
}
//#endregion









//#region Access Template
  const accountData = JSON.parse(localStorage.getItem("accountData"));
  
  if (!accountData?.accessTemplate?.hasChartOfAccounts) {
    return <NoAccess />;
  }
//#endregion





//#region UI
  return (
    <>
      <div className="p-6 bg-gray-50 min-h-screen">
        {/* Header Section */}
        <button 
          onClick={backToAllList}
          className="group flex items-center gap-2 text-sm font-medium text-gray-500 hover:text-gray-900 transition-colors mb-4"
        >
          <div className="p-2 rounded-full group-hover:bg-gray-100 transition-all">
            <ArrowBackIcon fontSize="small" />
          </div>
          Back to All List
        </button>

        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
          <div>
            <h2 className="text-3xl font-bold text-gray-800 flex items-center gap-3">
              <AccountBalanceWalletIcon fontSize="large" className="text-theme-color" />
              {mainAccount?.accountName}
            </h2>
          </div>
          <div className="flex gap-3">
            <button onClick={()=>allTransactionHandleClick(mainAccount)} className="flex items-center gap-2 bg-white border border-gray-300 px-4 py-2 rounded-lg text-sm font-semibold hover:bg-gray-50 transition shadow-sm">
              <ArticleIcon fontSize="small" /> All Transactions
            </button>
            <button onClick={openSelectForm} className="flex items-center gap-2 bg-theme-color text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-theme-color-h transition shadow-md">
              <AddCircleOutlineIcon fontSize="small" /> Add Sub Accounts
            </button>
          </div>
        </div>

        <CreateTable
          tableName={"GL Account"}
          headers={headers}
          accessors={accessors}
          data={data}
          actions={actions}

          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={10}
          totalItems={data?.length}
        />
      </div>

      <SubAccountsSelect
        visible={showSelectForm} onClose={closeSelectForm} modalName={"Select Sub Accounts"}
        data={selectedAccounts} setData={setSelectedAccounts}
        parentId={mainAccount?.id}
      />

      <ConfirmationModal 
        visible={showRemoveForm} 
        onClose={closeRemoveForm} 
        onSave={handleRemoveData} 
        modalName={"Remove"} 
        message={`Do you want to remove this sub account [ ${selectedData?.accountName ?? ""} ]?.`}
      />

      <ViewTransactionModal 
        visible={showTransactionForm}
        onClose={closeTransactionForm}
        // onSave={handleUpdateData}
        modalName={"Transactions"}

        data={selectedData}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
//#endregion
}
//#endregion










//#region AddUpdate Modal
const AddUpdateModal = ({
  visible, onClose, onSave, modalName,
  data,
  accountNumber, setAccountNumber,
  accountName, setAccountName,
  glAccountSubType, setGLAccountSubType,
  isactive, setIsactive,
}) => {
  const [failMessage, setFailMessage] = useState("");

  if (!visible) return null;

  const handleSubmit = async () => {
    if (!accountNumber || !accountName || !glAccountSubType) {
      setFailMessage("Please fill up required field/s.");
      return;
    }
    await onSave();
    closeModal();
  };

  const resetLocalVariables = () => {
    setFailMessage("");
  };

  const closeModal = () => {
    onClose();
    resetLocalVariables();
  };

  return (
    <>
      {/* Background overlay */}
      <AnimatePresence>
        {visible && (
          <motion.div
            // initial={{ opacity: 0 }}
            // animate={{ opacity: 1 }}
            // exit={{ opacity: 0 }}
            className="fixed inset-0 bg-gray-200 bg-opacity-70 flex items-center justify-center z-50"
          >
            {/* Modal container */}
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="bg-gray-100 rounded-2xl shadow-lg w-full max-w-lg p-8"
            >
              <h2 className="text-2xl font-semibold border-b pb-3 mb-6">
                {modalName}
              </h2>

              <div className="space-y-5 max-h-[500px] overflow-y-auto short:max-h-[300px] medium:h-[400px] pr-1">
                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700 ">
                    Account Number <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="e.g. 10001000"
                    className="w-full border border-gray-300  rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                    value={accountNumber}
                    onChange={(e) => setAccountNumber(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700 ">
                    Account Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="e.g. Asset"
                    className="w-full border border-gray-300  rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                    value={accountName}
                    onChange={(e) => setAccountName(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700 ">
                    Account Type <span className="text-red-500">*</span>
                  </label>
                  <GLAccountSubTypeSelect data={glAccountSubType} setData={setGLAccountSubType} isEditable={true}/>
                </div>

                <div className="flex items-center justify-between border border-gray-300 rounded-lg p-3 bg-white">
                  <span className="text-sm font-medium text-gray-700">
                    Active Status
                  </span>
                  <button
                    type="button"
                    onClick={() => setIsactive(!isactive)}
                    className={`relative inline-flex h-7 w-14 items-center rounded-full transition-colors duration-300 focus:outline-none ${
                      isactive ? "bg-theme-color" : "bg-gray-400"
                    }`}
                  >
                    <span
                      className={`inline-block h-5 w-5 transform rounded-full bg-white shadow-md transition-transform duration-300 ${
                        isactive ? "translate-x-7" : "translate-x-1"
                      }`}
                    />
                  </button>
                </div>
              </div>

              {/* Buttons */}
              <div className="flex justify-end space-x-3 mt-8 border-t pt-4">
                <button
                  onClick={closeModal}
                  className="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSubmit}
                  className="px-5 py-2 rounded-lg bg-theme-color text-white font-medium hover:opacity-90 transition"
                >
                  Save
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Alert */}
      <div className="fixed top-5 right-5 z-[9999] flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>
    </>
  );
};
//#endregion










//#region Manage Modal
const manageForm = [
  // {description: "Delivery Order", key: "deliveryOrder", type: "Receivables", subType: "Main"},
  {description: "Sales Invoice", key: "salesInvoice", type: "Receivables", subType: "Main"},
  {description: "Payment Received", key: "paymentReceived", type: "Receivables", subType: "Main"},
  {description: "Credit Note", key: "creditNote", type: "Receivables", subType: "Main"},
  {description: "VAT", key: "vat", type: "Receivables", subType: "Adjustments"},
  {description: "Discounts", key: "discounts", type: "Receivables", subType: "Adjustments"},
  // {description: "Zero Rated", key: "zeroRated", type: "Receivables", subType: "Adjustments"},
  {description: "EWT", key: "ewt", type: "Receivables", subType: "Adjustments"},



  // {description: "Goods Receipt", key: "goodsReceipt", type: "Payables", subType: "Main"},
  {description: "Expense", key: "expense", type: "Payables", subType: "Main"},
  {description: "Bill", key: "bill", type: "Payables", subType: "Main"},
  {description: "Payment", key: "payment", type: "Payables", subType: "Main"},
  {description: "Credit Note", key: "creditNote", type: "Payables", subType: "Main"},
  {description: "VAT", key: "vat", type: "Payables", subType: "Adjustments"},
  {description: "Discounts", key: "discounts", type: "Payables", subType: "Adjustments"},
  // {description: "Zero Rated", key: "zeroRated", type: "Payables", subType: "Adjustments"},
  {description: "EWT", key: "ewt", type: "Payables", subType: "Adjustments"},
]

const ManageModal = ({
  visible, onClose, onSave, modalName,
}) => {
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

// #region Tabs
  const [activeTab, setActiveTab] = useState("Receivables")

  const tabs = [
    {
      label:"Receivables",
      isActive: activeTab === "Receivables",
      onClick: () => setActiveTab("Receivables")
    },
    {
      label:"Payables",
      isActive: activeTab === "Payables",
      onClick: () => setActiveTab("Payables")
    },
  ]
//#endregion


  const fetchData = useCallback(async () => {
    try {
      setLoading(true);

      const response = await axios.get(`${apiUrl}/api/GLAccountConfiguration` , {
        headers: { 'Content-Type': 'application/json'}
      })
      
      setData(response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(()=> {
    if(visible){
      fetchData();
    }
  }, [visible, fetchData])

  const handleSubmit = async () => {
    const receivableKeys = [
      { description: "Delivery Order", key: "deliveryOrder" },
      { description: "Sales Invoice", key: "salesInvoice" },
      { description: "Payment Received", key: "paymentReceived" },
      { description: "Credit Note", key: "creditNote" },
      { description: "VAT", key: "vat" },
      { description: "Discounts", key: "discounts" },
      { description: "Zero Rated", key: "zeroRated" },
      { description: "EWT", key: "ewt" },
    ];
    const payableKeys = [
      { description: "Goods Receipt", key: "goodsReceipt" },
      { description: "Expense", key: "expense" },
      { description: "Bill", key: "bill" },
      { description: "Payment", key: "payment" },
      { description: "Credit Note", key: "creditNote" },
      { description: "VAT", key: "vat" },
      { description: "Discounts", key: "discounts" },
      { description: "Zero Rated", key: "zeroRated" },
      { description: "EWT", key: "ewt" },
    ];

    const _data = [
      ...receivableKeys.map(item => ({
        ...item,
        type: "Receivables",
        drGLAccountId: data?.find(d => d.type === "Receivables" && d.key === item.key)?.drGLAccountId,
        crGLAccountId: data?.find(d => d.type === "Receivables" && d.key === item.key)?.crGLAccountId,
        drPostingKeyId: data?.find(d => d.type === "Receivables" && d.key === item.key)?.drPostingKeyId,
        crPostingKeyId: data?.find(d => d.type === "Receivables" && d.key === item.key)?.crPostingKeyId,
      })),
      ...payableKeys.map(item => ({
        ...item,
        type: "Payables",
        drGLAccountId: data?.find(d => d.type === "Payables" && d.key === item.key)?.drGLAccountId,
        crGLAccountId: data?.find(d => d.type === "Payables" && d.key === item.key)?.crGLAccountId,
        drPostingKeyId: data?.find(d => d.type === "Payables" && d.key === item.key)?.drPostingKeyId,
        crPostingKeyId: data?.find(d => d.type === "Payables" && d.key === item.key)?.crPostingKeyId,
      }))
    ];

    try {
      setLoading(true);

      await axios.post(`${apiUrl}/api/GLAccountConfiguration`, _data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data added successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  };

  const resetLocalVariables = () => {
    setSuccessMessage("");
    setFailMessage("");
    setLoading(false);
    setData(null);
  };

  const closeModal = () => {
    onClose();
    resetLocalVariables();
  };

  const [currentKey, setCurrentKey] = useState(null); // vat, discounts, etc.
  const [currentTransactionType, setCurrentTransactionType] = useState(null); // Receivables or Payables
  const [currentDrCr, setCurrentDrCr] = useState(null); // Receivables or Payables
  const [showGLAccountSelectForm, setShowGLAccountSelectForm] = useState(false);
  const openGLAccountSelectForm = (transactionType, key, drCr ) => {
    setCurrentTransactionType(transactionType); // track Receivables or Payables
    setCurrentKey(key);
    setCurrentDrCr(drCr);
    setShowGLAccountSelectForm(true);
  };

  const closeGLAccountSelectForm = () => {
    setCurrentTransactionType(null);
    setCurrentKey(null);
    setCurrentDrCr(null);
    setShowGLAccountSelectForm(false);
  };

  const [showPostingKeyForm, setShowPostingKeyForm] = useState(false);

  const openPostingKeySelectForm = (transactionType, key, drCr) => {
    setCurrentTransactionType(transactionType); // track Receivables or Payables
    setCurrentKey(key);
    setCurrentDrCr(drCr);
    setShowPostingKeyForm(true);
  };
  const closePostingKeySelectForm = () => {
    setShowPostingKeyForm(false);
    setCurrentTransactionType(null);
    setCurrentKey(null);
    setCurrentDrCr(null);
  }

  if (!visible) return null;

  return (
    <>
      {/* Background overlay */}
      <AnimatePresence>
        {visible && (
          <motion.div
            // initial={{ opacity: 0 }}
            // animate={{ opacity: 1 }}
            // exit={{ opacity: 0 }}
            className="fixed inset-0 bg-gray-200 bg-opacity-70 flex items-center justify-center z-50"
          >
            {/* Modal container */}
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="bg-gray-100 rounded-2xl shadow-lg w-full max-w-7xl p-8"
            >
              <h2 className="text-2xl font-semibold border-b pb-3 mb-6">
                {modalName}
              </h2>

              <div className="space-y-5 max-h-[500px] overflow-y-auto short:max-h-[300px] medium:h-[400px] pr-1">
                {tabs.map((tab, index) => {
                  return (
                    <TabButton
                      key={index}
                      label={tab.label}
                      isActive={tab.isActive}
                      onClick={tab.onClick}
                    />
                  )
                })}

                {activeTab === "Receivables" &&
                  <div className="space-y-10">
                    <div className="space-y-4 md:col-span-2 mt-2">
                      <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 border-b pb-1">Main</h3>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      {manageForm?.filter(i => i.subType === "Main")?.map(item => {
                        if (item.type === "Receivables") {
                          return (
                            <div key={`${item.type} - ${item.key}`} className="space-y-1">
                              {/* Dr field */}
                              <label className="block text-sm font-semibold mb-1 text-gray-700">{item.description}</label>
                              <div className="flex flex-row items-center">
                                <label className="block text-xs text-gray-700">(Dr)</label>
                                <input
                                  type="text"
                                  placeholder="Select Account"
                                  className="ml-2 w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                                  value={data?.find(i => i.key === item.key && i.type === item.type)?.drGLAccountName || ""}
                                  readOnly
                                />
                                {!data?.find(i => i.key === item.key && i.type === item.type)?.drGLAccountName ? (
                                  <button
                                    className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg"
                                    onClick={() => openGLAccountSelectForm(item.type, item.key, "dr")}
                                  >
                                    <ManageSearchIcon className="text-white" />
                                  </button>
                                ) : (
                                  <button
                                    className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg"
                                    onClick={() => {
                                      setData(prev => prev.map(i => {
                                        if (i.key === item.key && i.type === item.type) {
                                          return { ...i, drGLAccountId: null, drGLAccountName: null, drGLAccountNumber: null };
                                        }
                                        return i;
                                      }));
                                    }}
                                  >
                                    <RemoveCircleIcon className="text-white" />
                                  </button>
                                )}
                              </div>

                              {/* Cr field */}
                              <div className="flex flex-row items-center">
                                <label className="block text-xs text-gray-700">(Cr)</label>
                                <input
                                  type="text"
                                  placeholder="Select Account"
                                  className="ml-2 w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                                  value={data?.find(i => i.key === item.key && i.type === item.type)?.crGLAccountName || ""}
                                  readOnly
                                />
                                {!data?.find(i => i.key === item.key && i.type === item.type)?.crGLAccountName ? (
                                  <button
                                    className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg"
                                    onClick={() => openGLAccountSelectForm(item.type, item.key, "cr")}
                                  >
                                    <ManageSearchIcon className="text-white" />
                                  </button>
                                ) : (
                                  <button
                                    className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg"
                                    onClick={() => {
                                      setData(prev => prev.map(i => {
                                        if (i.key === item.key && i.type === item.type) {
                                          return { ...i, crGLAccountId: null, crGLAccountName: null, crGLAccountNumber: null };
                                        }
                                        return i;
                                      }));
                                    }}
                                  >
                                    <RemoveCircleIcon className="text-white" />
                                  </button>
                                )}
                              </div>

                              {/* Dr Posting */}
                              <div className="hidden flex-row items-center">
                                <label className="block text-xs text-gray-700">(Dr PK)</label>
                                <input
                                  type="text"
                                  placeholder="Select Posting Key"
                                  className="ml-2 w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                                  value={data?.find(i => i.key === item.key && i.type === item.type)?.drPostingKeyDescription || ""}
                                  readOnly
                                />
                                {!data?.find(i => i.key === item.key && i.type === item.type)?.drPostingKeyDescription ? (
                                  <button
                                    className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg"
                                    onClick={() => openPostingKeySelectForm(item.type, item.key, "dr")}
                                  >
                                    <ManageSearchIcon className="text-white" />
                                  </button>
                                ) : (
                                  <button
                                    className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg"
                                    onClick={() => {
                                      setData(prev => prev.map(i => {
                                        if (i.key === item.key && i.type === item.type) {
                                          return { ...i, drPostingKeyId: null, drPostingKeyDescription: null, drPostingKeyCode: null };
                                        }
                                        return i;
                                      }));
                                    }}
                                  >
                                    <RemoveCircleIcon className="text-white" />
                                  </button>
                                )}
                              </div>

                              {/* Cr Posting */}
                              <div className="hidden flex-row items-center">
                                <label className="block text-xs text-gray-700">(Cr PK)</label>
                                <input
                                  type="text"
                                  placeholder="Select Posting Key"
                                  className="ml-2 w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                                  value={data?.find(i => i.key === item.key && i.type === item.type)?.crPostingKeyDescription || ""}
                                  readOnly
                                />
                                {!data?.find(i => i.key === item.key && i.type === item.type)?.crPostingKeyDescription ? (
                                  <button
                                    className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg"
                                    onClick={() => openPostingKeySelectForm(item.type, item.key, "cr")}
                                  >
                                    <ManageSearchIcon className="text-white" />
                                  </button>
                                ) : (
                                  <button
                                    className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg"
                                    onClick={() => {
                                      setData(prev => prev.map(i => {
                                        if (i.key === item.key && i.type === item.type) {
                                          return { ...i, crPostingKeyId: null, crPostingKeyDescription: null, crPostingKeyCode: null };
                                        }
                                        return i;
                                      }));
                                    }}
                                  >
                                    <RemoveCircleIcon className="text-white" />
                                  </button>
                                )}
                              </div>
                            </div>
                          );
                        }
                        return null;
                      })}
                    </div>
                    <div className="space-y-4 md:col-span-2 mt-2">
                      <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 border-b pb-1">Adjustments</h3>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      {manageForm?.filter(i => i.subType === "Adjustments")?.map(item => {
                        if (item.type === "Receivables") {
                          return (
                            <div key={`${item.type} - ${item.key}`} className="space-y-1">
                              {/* Dr field */}
                              <label className="block text-sm font-semibold mb-1 text-gray-700">{item.description}</label>
                              <div className="flex flex-row items-center">
                                <label className="block text-xs text-gray-700">(Dr)</label>
                                <input
                                  type="text"
                                  placeholder="Select Account"
                                  className="ml-2 w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                                  value={data?.find(i => i.key === item.key && i.type === item.type)?.drGLAccountName || ""}
                                  readOnly
                                />
                                {!data?.find(i => i.key === item.key && i.type === item.type)?.drGLAccountName ? (
                                  <button
                                    className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg"
                                    onClick={() => openGLAccountSelectForm(item.type, item.key, "dr")}
                                  >
                                    <ManageSearchIcon className="text-white" />
                                  </button>
                                ) : (
                                  <button
                                    className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg"
                                    onClick={() => {
                                      setData(prev => prev.map(i => {
                                        if (i.key === item.key && i.type === item.type) {
                                          return { ...i, drGLAccountId: null, drGLAccountName: null, drGLAccountNumber: null };
                                        }
                                        return i;
                                      }));
                                    }}
                                  >
                                    <RemoveCircleIcon className="text-white" />
                                  </button>
                                )}
                              </div>

                              {/* Cr field */}
                              <div className="flex flex-row items-center">
                                <label className="block text-xs text-gray-700">(Cr)</label>
                                <input
                                  type="text"
                                  placeholder="Select Account"
                                  className="ml-2 w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                                  value={data?.find(i => i.key === item.key && i.type === item.type)?.crGLAccountName || ""}
                                  readOnly
                                />
                                {!data?.find(i => i.key === item.key && i.type === item.type)?.crGLAccountName ? (
                                  <button
                                    className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg"
                                    onClick={() => openGLAccountSelectForm(item.type, item.key, "cr")}
                                  >
                                    <ManageSearchIcon className="text-white" />
                                  </button>
                                ) : (
                                  <button
                                    className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg"
                                    onClick={() => {
                                      setData(prev => prev.map(i => {
                                        if (i.key === item.key && i.type === item.type) {
                                          return { ...i, crGLAccountId: null, crGLAccountName: null, crGLAccountNumber: null };
                                        }
                                        return i;
                                      }));
                                    }}
                                  >
                                    <RemoveCircleIcon className="text-white" />
                                  </button>
                                )}
                              </div>

                              {/* Dr Posting */}
                              <div className="hidden flex-row items-center">
                                <label className="block text-xs text-gray-700">(Dr PK)</label>
                                <input
                                  type="text"
                                  placeholder="Select Posting Key"
                                  className="ml-2 w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                                  value={data?.find(i => i.key === item.key && i.type === item.type)?.drPostingKeyDescription || ""}
                                  readOnly
                                />
                                {!data?.find(i => i.key === item.key && i.type === item.type)?.drPostingKeyDescription ? (
                                  <button
                                    className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg"
                                    onClick={() => openPostingKeySelectForm(item.type, item.key, "dr")}
                                  >
                                    <ManageSearchIcon className="text-white" />
                                  </button>
                                ) : (
                                  <button
                                    className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg"
                                    onClick={() => {
                                      setData(prev => prev.map(i => {
                                        if (i.key === item.key && i.type === item.type) {
                                          return { ...i, drPostingKeyId: null, drPostingKeyDescription: null, drPostingKeyCode: null };
                                        }
                                        return i;
                                      }));
                                    }}
                                  >
                                    <RemoveCircleIcon className="text-white" />
                                  </button>
                                )}
                              </div>

                              {/* Cr Posting */}
                              <div className="hidden flex-row items-center">
                                <label className="block text-xs text-gray-700">(Cr PK)</label>
                                <input
                                  type="text"
                                  placeholder="Select Posting Key"
                                  className="ml-2 w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                                  value={data?.find(i => i.key === item.key && i.type === item.type)?.crPostingKeyDescription || ""}
                                  readOnly
                                />
                                {!data?.find(i => i.key === item.key && i.type === item.type)?.crPostingKeyDescription ? (
                                  <button
                                    className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg"
                                    onClick={() => openPostingKeySelectForm(item.type, item.key, "cr")}
                                  >
                                    <ManageSearchIcon className="text-white" />
                                  </button>
                                ) : (
                                  <button
                                    className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg"
                                    onClick={() => {
                                      setData(prev => prev.map(i => {
                                        if (i.key === item.key && i.type === item.type) {
                                          return { ...i, crPostingKeyId: null, crPostingKeyDescription: null, crPostingKeyCode: null };
                                        }
                                        return i;
                                      }));
                                    }}
                                  >
                                    <RemoveCircleIcon className="text-white" />
                                  </button>
                                )}
                              </div>
                            </div>
                          );
                        }
                        return null;
                      })}
                    </div>
                  </div>
                }
                {activeTab === "Payables" &&
                  <div className="space-y-10">
                    <div className="space-y-4 md:col-span-2 mt-2">
                      <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 border-b pb-1">Main</h3>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      {manageForm?.filter(i => i.subType === "Main")?.map(item => {
                        if (item.type === "Payables") {
                          return (
                            <div key={`${item.type} - ${item.key}`} className="space-y-1">
                              {/* Dr field */}
                              <label className="block text-sm font-semibold mb-1 text-gray-700">{item.description}</label>
                              <div className="flex flex-row items-center">
                                <label className="block text-xs text-gray-700">(Dr)</label>
                                <input
                                  type="text"
                                  placeholder="Select Account"
                                  className="ml-2 w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                                  value={data?.find(i => i.key === item.key && i.type === item.type)?.drGLAccountName || ""}
                                  readOnly
                                />
                                {!data?.find(i => i.key === item.key && i.type === item.type)?.drGLAccountName ? (
                                  <button
                                    className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg"
                                    onClick={() => openGLAccountSelectForm(item.type, item.key, "dr")}
                                  >
                                    <ManageSearchIcon className="text-white" />
                                  </button>
                                ) : (
                                  <button
                                    className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg"
                                    onClick={() => {
                                      setData(prev => prev.map(i => {
                                        if (i.key === item.key && i.type === item.type) {
                                          return { ...i, drGLAccountId: null, drGLAccountName: null, drGLAccountNumber: null };
                                        }
                                        return i;
                                      }));
                                    }}
                                  >
                                    <RemoveCircleIcon className="text-white" />
                                  </button>
                                )}
                              </div>

                              {/* Cr field */}
                              <div className="flex flex-row items-center">
                                <label className="block text-xs text-gray-700">(Cr)</label>
                                <input
                                  type="text"
                                  placeholder="Select Account"
                                  className="ml-2 w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                                  value={data?.find(i => i.key === item.key && i.type === item.type)?.crGLAccountName || ""}
                                  readOnly
                                />
                                {!data?.find(i => i.key === item.key && i.type === item.type)?.crGLAccountName ? (
                                  <button
                                    className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg"
                                    onClick={() => openGLAccountSelectForm(item.type, item.key, "cr")}
                                  >
                                    <ManageSearchIcon className="text-white" />
                                  </button>
                                ) : (
                                  <button
                                    className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg"
                                    onClick={() => {
                                      setData(prev => prev.map(i => {
                                        if (i.key === item.key && i.type === item.type) {
                                          return { ...i, crGLAccountId: null, crGLAccountName: null, crGLAccountNumber: null };
                                        }
                                        return i;
                                      }));
                                    }}
                                  >
                                    <RemoveCircleIcon className="text-white" />
                                  </button>
                                )}
                              </div>

                              {/* Dr Posting */}
                              <div className="hidden flex-row items-center">
                                <label className="block text-xs text-gray-700">(Dr PK)</label>
                                <input
                                  type="text"
                                  placeholder="Select Posting Key"
                                  className="ml-2 w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                                  value={data?.find(i => i.key === item.key && i.type === item.type)?.drPostingKeyDescription || ""}
                                  readOnly
                                />
                                {!data?.find(i => i.key === item.key && i.type === item.type)?.drPostingKeyDescription ? (
                                  <button
                                    className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg"
                                    onClick={() => openPostingKeySelectForm(item.type, item.key, "dr")}
                                  >
                                    <ManageSearchIcon className="text-white" />
                                  </button>
                                ) : (
                                  <button
                                    className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg"
                                    onClick={() => {
                                      setData(prev => prev.map(i => {
                                        if (i.key === item.key && i.type === item.type) {
                                          return { ...i, drPostingKeyId: null, drPostingKeyDescription: null, drPostingKeyCode: null };
                                        }
                                        return i;
                                      }));
                                    }}
                                  >
                                    <RemoveCircleIcon className="text-white" />
                                  </button>
                                )}
                              </div>

                              {/* Cr Posting */}
                              <div className="hidden flex-row items-center">
                                <label className="block text-xs text-gray-700">(Cr PK)</label>
                                <input
                                  type="text"
                                  placeholder="Select Posting Key"
                                  className="ml-2 w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                                  value={data?.find(i => i.key === item.key && i.type === item.type)?.crPostingKeyDescription || ""}
                                  readOnly
                                />
                                {!data?.find(i => i.key === item.key && i.type === item.type)?.crPostingKeyDescription ? (
                                  <button
                                    className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg"
                                    onClick={() => openPostingKeySelectForm(item.type, item.key, "cr")}
                                  >
                                    <ManageSearchIcon className="text-white" />
                                  </button>
                                ) : (
                                  <button
                                    className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg"
                                    onClick={() => {
                                      setData(prev => prev.map(i => {
                                        if (i.key === item.key && i.type === item.type) {
                                          return { ...i, crPostingKeyId: null, crPostingKeyDescription: null, crPostingKeyCode: null };
                                        }
                                        return i;
                                      }));
                                    }}
                                  >
                                    <RemoveCircleIcon className="text-white" />
                                  </button>
                                )}
                              </div>
                            </div>
                          );
                        }
                        return null;
                      })}
                    </div>
                    <div className="space-y-4 md:col-span-2 mt-2">
                      <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 border-b pb-1">Adjustments</h3>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      {manageForm?.filter(i => i.subType === "Adjustments")?.map(item => {
                        if (item.type === "Payables") {
                          return (
                            <div key={`${item.type} - ${item.key}`} className="space-y-1">
                              {/* Dr field */}
                              <label className="block text-sm font-semibold mb-1 text-gray-700">{item.description}</label>
                              <div className="flex flex-row items-center">
                                <label className="block text-xs text-gray-700">(Dr)</label>
                                <input
                                  type="text"
                                  placeholder="Select Account"
                                  className="ml-2 w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                                  value={data?.find(i => i.key === item.key && i.type === item.type)?.drGLAccountName || ""}
                                  readOnly
                                />
                                {!data?.find(i => i.key === item.key && i.type === item.type)?.drGLAccountName ? (
                                  <button
                                    className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg"
                                    onClick={() => openGLAccountSelectForm(item.type, item.key, "dr")}
                                  >
                                    <ManageSearchIcon className="text-white" />
                                  </button>
                                ) : (
                                  <button
                                    className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg"
                                    onClick={() => {
                                      setData(prev => prev.map(i => {
                                        if (i.key === item.key && i.type === item.type) {
                                          return { ...i, drGLAccountId: null, drGLAccountName: null, drGLAccountNumber: null };
                                        }
                                        return i;
                                      }));
                                    }}
                                  >
                                    <RemoveCircleIcon className="text-white" />
                                  </button>
                                )}
                              </div>

                              {/* Cr field */}
                              <div className="flex flex-row items-center">
                                <label className="block text-xs text-gray-700">(Cr)</label>
                                <input
                                  type="text"
                                  placeholder="Select Account"
                                  className="ml-2 w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                                  value={data?.find(i => i.key === item.key && i.type === item.type)?.crGLAccountName || ""}
                                  readOnly
                                />
                                {!data?.find(i => i.key === item.key && i.type === item.type)?.crGLAccountName ? (
                                  <button
                                    className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg"
                                    onClick={() => openGLAccountSelectForm(item.type, item.key, "cr")}
                                  >
                                    <ManageSearchIcon className="text-white" />
                                  </button>
                                ) : (
                                  <button
                                    className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg"
                                    onClick={() => {
                                      setData(prev => prev.map(i => {
                                        if (i.key === item.key && i.type === item.type) {
                                          return { ...i, crGLAccountId: null, crGLAccountName: null, crGLAccountNumber: null };
                                        }
                                        return i;
                                      }));
                                    }}
                                  >
                                    <RemoveCircleIcon className="text-white" />
                                  </button>
                                )}
                              </div>

                              {/* Dr Posting */}
                              <div className="hidden flex-row items-center">
                                <label className="block text-xs text-gray-700">(Dr PK)</label>
                                <input
                                  type="text"
                                  placeholder="Select Posting Key"
                                  className="ml-2 w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                                  value={data?.find(i => i.key === item.key && i.type === item.type)?.drPostingKeyDescription || ""}
                                  readOnly
                                />
                                {!data?.find(i => i.key === item.key && i.type === item.type)?.drPostingKeyDescription ? (
                                  <button
                                    className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg"
                                    onClick={() => openPostingKeySelectForm(item.type, item.key, "dr")}
                                  >
                                    <ManageSearchIcon className="text-white" />
                                  </button>
                                ) : (
                                  <button
                                    className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg"
                                    onClick={() => {
                                      setData(prev => prev.map(i => {
                                        if (i.key === item.key && i.type === item.type) {
                                          return { ...i, drPostingKeyId: null, drPostingKeyDescription: null, drPostingKeyCode: null };
                                        }
                                        return i;
                                      }));
                                    }}
                                  >
                                    <RemoveCircleIcon className="text-white" />
                                  </button>
                                )}
                              </div>

                              {/* Cr Posting */}
                              <div className="hidden flex-row items-center">
                                <label className="block text-xs text-gray-700">(Cr PK)</label>
                                <input
                                  type="text"
                                  placeholder="Select Posting Key"
                                  className="ml-2 w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                                  value={data?.find(i => i.key === item.key && i.type === item.type)?.crPostingKeyDescription || ""}
                                  readOnly
                                />
                                {!data?.find(i => i.key === item.key && i.type === item.type)?.crPostingKeyDescription ? (
                                  <button
                                    className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg"
                                    onClick={() => openPostingKeySelectForm(item.type, item.key, "cr")}
                                  >
                                    <ManageSearchIcon className="text-white" />
                                  </button>
                                ) : (
                                  <button
                                    className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg"
                                    onClick={() => {
                                      setData(prev => prev.map(i => {
                                        if (i.key === item.key && i.type === item.type) {
                                          return { ...i, crPostingKeyId: null, crPostingKeyDescription: null, crPostingKeyCode: null };
                                        }
                                        return i;
                                      }));
                                    }}
                                  >
                                    <RemoveCircleIcon className="text-white" />
                                  </button>
                                )}
                              </div>
                            </div>
                          );
                        }
                        return null;
                      })}
                    </div>
                  </div>
                }
              </div>

              {/* Buttons */}
              <div className="flex justify-end space-x-3 mt-8 border-t pt-4">
                <button
                  onClick={closeModal}
                  className="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSubmit}
                  className="px-5 py-2 rounded-lg bg-theme-color text-white font-medium hover:opacity-90 transition"
                >
                  Save
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <ChartOfAccountsSelect
        visible={showGLAccountSelectForm}
        onClose={closeGLAccountSelectForm}
        modalName={"Select Account"}
        data={data} // full current data array
        setData={(selectedAccount) => {
          setData(prev => {
            // Find if the item already exists
            const index = prev.findIndex(
              item => item.key === currentKey && item.type === currentTransactionType
            );

            if (index > -1) {
              // Item exists → update Dr or Cr
              return prev.map((item, i) => {
                if (i === index) {
                  if (currentDrCr === "dr") {
                    return {
                      ...item,
                      drGLAccountId: selectedAccount.id,
                      drGLAccountName: selectedAccount.accountName,
                      drGLAccountNumber: selectedAccount.accountNumber,
                    };
                  } else {
                    return {
                      ...item,
                      crGLAccountId: selectedAccount.id,
                      crGLAccountName: selectedAccount.accountName,
                      crGLAccountNumber: selectedAccount.accountNumber,
                    };
                  }
                }
                return item;
              });
            } else {
              // Item doesn't exist → insert new
              return [
                ...prev,
                {
                  key: currentKey,
                  type: currentTransactionType,
                  description: currentKey, // you can map to a proper description if needed
                  drGLAccountId: currentDrCr === "dr" ? selectedAccount.id : null,
                  drGLAccountName: currentDrCr === "dr" ? selectedAccount.accountName : null,
                  drGLAccountNumber: currentDrCr === "dr" ? selectedAccount.accountNumber : null,
                  crGLAccountId: currentDrCr === "cr" ? selectedAccount.id : null,
                  crGLAccountName: currentDrCr === "cr" ? selectedAccount.accountName : null,
                  crGLAccountNumber: currentDrCr === "cr" ? selectedAccount.accountNumber : null,
                }
              ];
            }
          });

          closeGLAccountSelectForm();
        }}
      />

      <PostingKeySelect 
        visible={showPostingKeyForm} 
        onClose={closePostingKeySelectForm}
        modalName={"Select Posting Key"}
        data={data} 
        setData={(selectedAccount) => {
          setData(prev => {
            // Find if the item already exists
            const index = prev.findIndex(
              item => item.key === currentKey && item.type === currentTransactionType
            );

            if (index > -1) {
              // Item exists → update Dr or Cr
              return prev.map((item, i) => {
                if (i === index) {
                  if (currentDrCr === "dr") {
                    return {
                      ...item,
                      drPostingKeyId: selectedAccount.id,
                      drPostingKeyDescription: selectedAccount.description,
                      drPostingKeyCode: selectedAccount.postingKeyCode,
                    };
                  } else {
                    return {
                      ...item,
                      crPostingKeyId: selectedAccount.id,
                      crPostingKeyDescription: selectedAccount.description,
                      crPostingKeyCode: selectedAccount.postingKeyCode,
                    };
                  }
                }
                return item;
              });
            } else {
              // Item doesn't exist → insert new
              return [
                ...prev,
                {
                  key: currentKey,
                  type: currentTransactionType,
                  description: currentKey, // you can map to a proper description if needed
                  drPostingKeyId: currentDrCr === "dr" ? selectedAccount.id : null,
                  drPostingKeyDescription: currentDrCr === "dr" ? selectedAccount.description : null,
                  drPostingKeyCode: currentDrCr === "dr" ? selectedAccount.postingKeyCode : null,
                  crPostingKeyId: currentDrCr === "cr" ? selectedAccount.id : null,
                  crPostingKeyDescription: currentDrCr === "cr" ? selectedAccount.description : null,
                  crPostingKeyCode: currentDrCr === "cr" ? selectedAccount.postingKeyCode : null,
                }
              ];
            }
          });

          closeGLAccountSelectForm();
        }}
        type={currentTransactionType === "Receivables" ? "AR" :
          currentTransactionType === "Payables" ? "AP" :
          "GJ"
        } // <-- pass AR or AP here
      />


      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
};
//#endregion










//#region Transaction
const ViewTransactionModal = ({
  visible, onClose, onSave, modalName,
  data,
}) => {
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
  const [loading, setLoading] = useState(false)
  const [currentPageGLAccountTransaction, setCurrentPageGLAccountTransaction] = useState(1);
  
  // --- Calculation Logic ---
  const transactions = data?.glAccountTransactions || [];
  
  const totalDebit = transactions.filter(i => i.debitCredit === "Debit").reduce((sum, item) => sum + (Number(item.amount) || 0), 0);
  const totalCredit = transactions.filter(i => i.debitCredit === "Credit").reduce((sum, item) => sum + (Number(item.amount) || 0), 0);
  const balance = totalDebit - totalCredit;

  const formatSummary = (val) => {
    const symbol = getCurrency?.symbol || "₱";
    // Ensure we pass 0 if value is null/undefined to avoid console errors
    return `${symbol}${FormatValueToDecimal(val || 0)}`;
  };

  const headersGLAccountTransaction = [
    'ACCOUNT', 
    'DESCRIPTION', 
    'DETAILS', 
    'TYPE', 
    'REFERENCE #', 
    'DEBIT', 
    'CREDIT', 
  ]
  const accessorsGLAccountTransaction = [
    'account', 
    'description', 
    'details', 
    'referenceTypeDescription', 
    'referenceNumber', 
    'debit', 
    'credit', 
  ]

  const actionsGLAccountTransaction = [];

  const resetLocalVariables = () => {
    setCurrentPageGLAccountTransaction(1);
    setLoading(false);
  }

  const closeModal = () => {
    onClose();
    resetLocalVariables();
  }

  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-50 rounded-2xl shadow-2xl w-full max-w-7xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center shrink-0">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500 font-medium">General Ledger Transaction Overview</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="p-8 overflow-y-auto custom-scrollbar flex-grow">
              
              {/* Summary Ribbon */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                {/* Debit Card */}
                <div className="bg-white p-5 rounded-2xl border border-gray-200 shadow-sm flex items-center group hover:border-emerald-200 transition-colors">
                  <div className="w-12 h-12 bg-emerald-50 rounded-xl flex items-center justify-center text-emerald-600 mr-4 shrink-0">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1">Total Debit</p>
                    <p className="text-xl font-extrabold text-gray-900">{formatSummary(totalDebit)}</p>
                  </div>
                </div>

                {/* Credit Card */}
                <div className="bg-white p-5 rounded-2xl border border-gray-200 shadow-sm flex items-center group hover:border-rose-200 transition-colors">
                  <div className="w-12 h-12 bg-rose-50 rounded-xl flex items-center justify-center text-rose-600 mr-4 shrink-0">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 12H4" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1">Total Credit</p>
                    <p className="text-xl font-extrabold text-gray-900">{formatSummary(totalCredit)}</p>
                  </div>
                </div>

                {/* Net Balance Card */}
                <div className={`bg-white p-5 rounded-2xl border-2 shadow-sm flex items-center transition-colors ${balance >= 0 ? 'border-green-100 hover:border-green-300' : 'border-red-100 hover:border-red-300'}`}>
                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center mr-4 shrink-0 ${balance >= 0 ? 'bg-green-50 text-green-600' : 'bg-red-50 text-red-600'}`}>
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1">Net Balance</p>
                    <p className={`text-xl font-extrabold ${balance >= 0 ? 'text-green-500' : 'text-red-500'}`}>
                      {`${balance < 0 ? "-" : ""} ${formatSummary(Math.abs(balance))}`}
                    </p>
                  </div>
                </div>
              </div>

              {/* Table Container */}
              <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
                <CreateTable
                  tableName={"GL Account Transaction"}
                  headers={headersGLAccountTransaction}
                  accessors={accessorsGLAccountTransaction}
                  data={data?.glAccountTransactions}
                  actions={actionsGLAccountTransaction}
                  currentPage={currentPageGLAccountTransaction}
                  setCurrentPage={setCurrentPageGLAccountTransaction}
                  itemsPerPage={10}
                  totalItems={data?.glAccountTransactions?.length}
                />
              </div>
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4 shrink-0">
              <button
                onClick={closeModal}
                className="px-8 py-2.5 rounded-xl border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-bold text-sm"
              >
                Close
              </button>
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>
      
      { loading && <Loading />}
    </>
  );
};
//#endregion










//#region Upload Form
const UploadForm = ({
  visible, onClose, modalName, onSave,
  uploadedData, setUploadedData,
  data,
}) => {
  const [loading, setLoading] = useState(false);
  const [failMessage, setFailMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [file, setFile] = useState(null);
  const [hasError, setHasError] = useState(false);

  const handleFileChange = async (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    setFile(selectedFile);

    try {
      const workbook = new ExcelJS.Workbook();
      const arrayBuffer = await selectedFile.arrayBuffer();
      await workbook.xlsx.load(arrayBuffer);

      const isValidValue = (value) => {
        if (value === null || value === undefined) return false;

        if (typeof value === "string") {
          // Remove zero-width / invisible characters
          const cleaned = value.replace(/[\u200B-\u200D\uFEFF]/g, "").trim();

          if (cleaned === "") return false;

          // Reject placeholder-like <...>
          if (/^<.*>$/.test(cleaned)) return false;

          return true;
        }

        return true;
      };

      const accountSheet = workbook.getWorksheet("Account");
      const accountData = [];

      accountSheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
        if (rowNumber === 1) return;
        const accountNumber = row.getCell(1).value;
        const accountName = row.getCell(2).value;
        const glAccountSubType = row.getCell(3).value;

        if(isValidValue(accountNumber) || isValidValue(accountName) || isValidValue(glAccountSubType)){
          accountData.push({
            accountNumber: isValidValue(accountNumber) ? accountNumber : "",
            accountName: isValidValue(accountName) ? accountName : "",
            glAccountSubType: isValidValue(glAccountSubType) ? glAccountSubType : null,
            createdBy: accountData?.id,
          });
        }
      });

      // ===== MERGE DATA BY borrowerId =====
      const mergedData = accountData
      .map((p) => {
        let _errors = [];

        const existingAccountNumber = data.find(
          i => i.accountNumber?.toString() === p.accountNumber?.toString()
        );

        if (existingAccountNumber) {
          _errors.push("Account Number already exists.");
          setHasError(true);
        }

        if (!p.accountNumber) {
          _errors.push("Account number is required.");
          setHasError(true);
        }

        if (!p.accountName) {
          _errors.push("Account name is required.");
          setHasError(true);
        }

        if (!p.glAccountSubType) {
          _errors.push("Account Type is required.");
          setHasError(true);
        }

        return {
          accountNumber: String(p.accountNumber),
          accountName: p.accountName || "",
          glAccountSubType: p.glAccountSubType || "",
          errors: _errors.join(" | ")
        };
      })
      .sort((a, b) => {
        const aHasError = a.errors ? 1 : 0;
        const bHasError = b.errors ? 1 : 0;

        return bHasError - aHasError; // errors first
      });
      
      setUploadedData(mergedData);

    } catch (error) {
      console.error("Error reading Excel file:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    await onSave();
    closeModal();
  };

  const resetLocalVariables = () => {
    setSuccessMessage("");
    setFailMessage("");
    setLoading(false);
    setHasError(false);
    setUploadedData([]);
    setCurrentPage(1);
    setFile(null)
  };

  const closeModal = () => {
    onClose();
    resetLocalVariables();
  };

//#region Upload Table
  const [currentPage, setCurrentPage] = useState(1);

  const headers = [
    'ACCOUNT NUMBER', 
    'ACCOUNT NAME', 
    'ACCOUNT TYPE', 
    'ERRORS',
  ]
  const accessors = [
    'accountNumber', 
    'accountName', 
    'glAccountSubType', 
    'errors',
  ]
//#endregion

  if (!visible) return null;

  return (
    <>
      {/* Background overlay */}
      <AnimatePresence>
        {visible && (
          <motion.div
            // initial={{ opacity: 0 }}
            // animate={{ opacity: 1 }}
            // exit={{ opacity: 0 }}
            className="fixed inset-0 bg-gray-200 bg-opacity-70 flex items-center justify-center z-50"
          >
            {/* Modal container */}
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="bg-gray-100 rounded-2xl shadow-lg w-full max-w-7xl p-8"
            >
              <h2 className="text-2xl font-semibold border-b pb-3 mb-6">
                {modalName}
              </h2>

              <div className="space-y-5 max-h-[500px] overflow-y-auto short:max-h-[300px] medium:h-[400px] pr-1">
                {/* Upload Section */}
                <div>
                  <div
                    onClick={() => document.getElementById("fileInput").click()}
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => {
                      e.preventDefault();
                      if (e.dataTransfer.files && e.dataTransfer.files[0]) {
                        handleFileChange({ target: { files: e.dataTransfer.files } });
                      }
                    }}
                    className="flex flex-col items-center justify-center border-2 border-dashed border-gray-400 rounded-lg h-40 cursor-pointer bg-gray-50 hover:bg-gray-100 transition"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-12 w-12 text-gray-400 mb-2"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M7 16v-4m0 0l-4 4m4-4l4 4M17 8v4m0 0l4-4m-4 4l-4-4"
                      />
                    </svg>
                    <span className="text-gray-600 font-medium text-center">
                      Drag and drop file here <br /> or click to upload
                    </span>
                  </div>

                  {/* Hidden input */}
                  <input
                    type="file"
                    id="fileInput"
                    accept=".xlsx,.xls,.csv"
                    onChange={handleFileChange}
                    className="hidden"
                  />

                  {/* Show selected file name */}
                  {file && (
                    <div className="text-gray-700 mt-2">
                      Selected file: <span className="font-medium">{file.name}</span>
                    </div>
                  )}
                </div>

                {/* Preview */}
                {file &&
                <div>
                  <CreateTable
                    tableName={"Borrowers List Upload"}
                    headers={headers}
                    accessors={accessors}
                    data={uploadedData}
                    actions={[]}

                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    itemsPerPage={10}
                    totalItems={uploadedData?.length}
                  />
                </div>}
              </div>
              {/* Buttons */}
              <div className="flex justify-end space-x-3 mt-8 border-t pt-4">
                <button
                  onClick={closeModal}
                  className="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
                >
                  Cancel
                </button>
                
                <button
                  onClick={handleSubmit}
                  disabled={!file || hasError || uploadedData.length <= 0}
                  className={`px-5 py-2 rounded-lg ${!file || hasError || uploadedData.length <= 0 ? "bg-gray-300 cursor-not-allowed" : "bg-theme-color"} text-white font-medium hover:opacity-90 transition`}
                >
                  Proceed
                </button>
              </div>
              <div className="flex gap-2 justify-end">
                {!file &&
                  <span className="text-red-500 text-xs">No file uploaded.</span>
                }
                {hasError &&
                  <span className="text-red-500 text-xs">Your data has error.</span>
                }
                {file && uploadedData.length <= 0 &&
                  <span className="text-red-500 text-xs">No data available.</span>
                }
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Alert */}
      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
};
//#endregion









//#region Filter
const FilterModal = ({
  visible, onClose, modalName,
  glAccountSubTypeFilter, setGLAccountSubTypeFilter,
}) => {
  const [failMessage, setFailMessage] = useState("");
  const [_glAccountSubTypeFilter, _setGLAccountSubTypeFilter] = useState(glAccountSubTypeFilter);

  useEffect(() => {
    if(visible){
      _setGLAccountSubTypeFilter(glAccountSubTypeFilter)
    }
  }, [visible, glAccountSubTypeFilter ])

  const handleSubmit = async () => {
    setGLAccountSubTypeFilter(_glAccountSubTypeFilter);
    closeModal();
  };

  const resetLocalVariables = () => {
    setFailMessage("");
  };

  const closeModal = () => {
    onClose();
    resetLocalVariables();
  };

  if (!visible) return null;

  return (
    <>
      {/* Background overlay */}
      <AnimatePresence>
        {visible && (
          <motion.div
            // initial={{ opacity: 0 }}
            // animate={{ opacity: 1 }}
            // exit={{ opacity: 0 }}
            className="fixed inset-0 bg-gray-200 bg-opacity-70 flex items-center justify-center z-50"
          >
            {/* Modal container */}
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="bg-gray-100 rounded-2xl shadow-lg w-full max-w-lg p-8"
            >
              <h2 className="text-2xl font-semibold border-b pb-3 mb-6">
                {modalName}
              </h2>

              <div className="space-y-5 max-h-[500px] overflow-y-auto short:max-h-[300px] medium:h-[400px] pr-1">
                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">
                    Sub Type
                  </label>
                  <GLAccountSubTypeSelectWithAll data={_glAccountSubTypeFilter} setData={_setGLAccountSubTypeFilter} isEditable={true}/>
                </div>
              </div>

              {/* Buttons */}
              <div className="flex justify-end space-x-3 mt-8 border-t pt-4">
                <button
                  onClick={closeModal}
                  className="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSubmit}
                  className="px-5 py-2 rounded-lg bg-theme-color text-white font-medium hover:opacity-90 transition"
                >
                  Save
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Alert */}
      <div className="fixed top-5 right-5 z-[9999] flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>
    </>
  );
};
//#endregion